/**
 * A path this app does not serve.
 *
 * It is rendered outside the shell and outside the guard, so it works whether
 * or not there is a session — a 404 that first demands a login is worse than
 * the 404 itself.
 */
import { buttonVariants } from '@wend/ui';
import { Link } from 'react-router-dom';

import { useAuth } from '../auth/auth-context';
import { AuthLayout } from '../components/AuthLayout';

export function NotFoundPage() {
  const { status } = useAuth();
  const target = status === 'authenticated' ? '/' : '/login';

  return (
    <AuthLayout
      title="Page not found"
      description="That address does not point at anything in Wend."
    >
      <Link to={target} replace className={buttonVariants({ variant: 'secondary', fullWidth: true })}>
        {status === 'authenticated' ? 'Back to your workspace' : 'Go to sign in'}
      </Link>
    </AuthLayout>
  );
}
